export { Box } from '@theme-ui/components';
export type { BoxProps } from '@theme-ui/components';
